console.log(process.env);
const firebaseConfig = {
  apiKey: "AIzaSyBPpi84pNErCYE6bqTVCelcYc_DmrY4hik",
  authDomain: "medicenter-dentist.firebaseapp.com",
  projectId: "medicenter-dentist",
  storageBucket: "medicenter-dentist.appspot.com",
  messagingSenderId: "689227992182",
  appId: "1:689227992182:web:458060537058e951cb2357",
};

export default firebaseConfig;
